export default __webpack_public_path__ + "static/media/6-4.673e7e84.png";